import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '@/modules/shared/lib/axios';
import { MINUTE_IN_MS } from '@/modules/shared/constants/time';
import { CountryDetailsModel } from '@/modules/shared/types/country';

type Props = {
  companyId: string
}

/**
 * Fetches available countries.
 */
export function useQueryCountriesDetails({ companyId }: Props) {
  return useQuery<CountryDetailsModel[]>({
    queryKey: ['config.countriesDetails', companyId],
    queryFn: async () => {
      // @TODO remove companyId from queryKey and endpoint when backend is fixed
      const { data } = await axiosInstance.get(`/api/${companyId}/configuration/country`);
      return data;
    },
    staleTime: MINUTE_IN_MS * 60, // cache for 60 minutes
  });
}
